import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import DiscussionList from 'flarum/forum/components/DiscussionList';
import DiscussionListState from 'flarum/forum/states/DiscussionListState';
import PopularDiscussions from './PopularDiscussions';
const t = function (key, params) {
  if (params === void 0) {
    params = {};
  }
  return app.translator.trans(`tarotportal-theme.forum.home.${key}`, params);
};

/** How many discussions the home page block shows; the full list is "Все темы". */
const LATEST_COUNT = 6;

/** Core's list state, one page of LATEST_COUNT and no "load more" (only for this block). */
class LatestDiscussionsState extends DiscussionListState {
  constructor(params) {
    super(params);
    this.pageSize = LATEST_COUNT;
  }
  hasNext() {
    return false;
  }
}

/** "Свежие темы" (core discussion list, latest activity first, LATEST_COUNT of them) with "Популярное за 24 часа" beside it. */
export default class LatestDiscussions extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.state = new LatestDiscussionsState({
      sort: 'latest'
    });
    this.state.refresh();
  }
  view() {
    return m("section", {
      className: "TpBlock TpLatest"
    }, m("div", {
      className: "TpLatest-main"
    }, m("div", {
      className: "TpBlock-head"
    }, m("h2", {
      className: "TpBlock-title"
    }, t('latest_title')), m(Link, {
      className: "TpArrowLink",
      href: app.route('index')
    }, t('all_discussions'), " \u2192")), m(DiscussionList, {
      state: this.state
    })), m("aside", {
      className: "TpLatest-aside"
    }, m(PopularDiscussions, null)));
  }
}
flarum.reg.add('tarotportal-theme', 'forum/components/LatestDiscussions', LatestDiscussions);